import script from "./PayResult.vue?vue&type=script&setup=true&lang=js"
export * from "./PayResult.vue?vue&type=script&setup=true&lang=js"

import "./PayResult.vue?vue&type=style&index=0&id=0ec81802&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec81802"]])

export default __exports__